export default "__VITE_ASSET__C12M1gSI__"